/*
 * @Author: yangxu
 * @Description:
 * @Date: 2023-05-24 18:01:43
 * @LastEditTime: 2025-03-10 12:10:42
 * @FilePath: /js_zuhe-2023_src/src/api/index.js
 */
import request from "@/utils/request";
import Jsonp from "@/utils/Jsonp";

let _jsonpNum = 0;
const _isTest = window.location.host.match("test");

const homewayApi = _isTest
  ? "https://testgw.homeway.com.cn"
  : "https://gw.homeway.com.cn";

const regtoolHost = _isTest
  ? "https://test-regtool.hexun.com"
  : "https://regtool.hexun.com";

const callvipHost = _isTest
  ? "https://test-callvip.homeway.com.cn"
  : "https://callvip.homeway.com.cn";

/**
 * @description: 获取用户权限
 * @param {*} productid
 * @return {*}
 */
export function getuserright(productid) {
  _jsonpNum++;
  return Jsonp(`${callvipHost}/jsapi/right/getuserright`, { productid });
}

/**
 * @description: 获取详情基础数据
 * @param {*} apiNum
 * @param {*} params
 * @return {*}
 */
export function getDetail(apiNum, params) {
  return request({
    url: `${homewayApi}/weituo/auth/api/${apiNum}`,
    method: "get",
    params: {
      params,
      jsonp_callback: `callback`,
    },
  });
}

/**
 * @description: 获取组合信息
 * @return {*}
 */
export function getInfos() {
  return request({
    url: `${homewayApi}/entrust/api/combination/infos`,
    method: "get",
  });
}

/**
 * @description: 获取K线数据
 * @param {*} code 代码
 * @param {*} start 开始时间
 * @param {*} nummber 数量
 * @param {*} type 类型
 * @return {*}
 */
export function getStockDetail({ startDate, endDate }) {
  return request({
    url: `${homewayApi}/stockmatch-api/api/sseRate/getSse300RateList`,
    method: "get",
    params: {
      startDate,
      endDate,
    },
  });
}

/**
 * @description: 获取推送配置
 * @param {*} type
 * @return {*}
 */
export function getPushInfo(type) {
  return request({
    url: `${homewayApi}/weixin/push/config/info`,
    method: "get",
    params: {
      type,
    },
  });
}

/**
 * @description: 保存推送配置
 * @param {*} type
 * @return {*}
 */
export function savePushInfo({ type, quantification }) {
  return request({
    url: `${homewayApi}/weixin/push/config/save`,
    method: "get",
    params: {
      type,
      quantification,
    },
  });
}

/**
 * @description: 获取单品价格
 * @param {*} productid
 * @param {*} priceid
 * @return {*}
 */
export function getProductInfo(productid, priceid) {
  return Jsonp(`${callvipHost}/jsapi/product/get-product-info`, {
    productid,
    priceid,
  });
}

/**
 * @description: 获取套餐价格
 * @param {*} groupid
 * @param {*} getBindGroupInfo
 * @return {*}
 */
export function getPackageInfo(groupid, getBindGroupInfo) {
  return Jsonp(`${callvipHost}/jsapi/product/get-package-info`, {
    groupid,
    getBindGroupInfo,
  });
}
